import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from './../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly JWT_TOKEN = 'access_token';
  private readonly REFRESH_TOKEN = 'refresh_token';
  private readonly ORG = 'Org';
  private readonly CHILD_ORG = 'ChildOrg';
  private readonly FARM_ID = 'farmId';

  constructor(private http: HttpClient) { }

  isLoggedIn() {
    return !!this.getJwtToken();
  }

  refreshToken() {
    return this.http.post<any>(`${environment.API}${environment.URL_PLATFORM_REFRESH_TOKEN}`, {
      'refreshToken': this.getRefreshToken()
    }).pipe(tap(tokens => {
      if (tokens.code == 200) {
        this.storeTokens(tokens.data);
      }
    }), catchError(error => {

      return of(window.location.href = `${environment.GATEWAY_URL}/homepage`);
    }));
  }

  getPlatformInfo(authCode) {
    return this.http.get<any>(`${environment.API_GATEWAY}${environment.URL_GET_PLATFORM_INFO}?authCode=${authCode}`).pipe(catchError(error => {
      return of(error.error);
    }));
  }

  getAuthInfo() {
    let auth = {
      orgId: sessionStorage.getItem(this.ORG) ? sessionStorage.getItem(this.ORG) : null,
      childorgId: sessionStorage.getItem(this.CHILD_ORG) ? sessionStorage.getItem(this.CHILD_ORG) : null,
      farmId: sessionStorage.getItem(this.FARM_ID) ? sessionStorage.getItem(this.FARM_ID) : null
    }
    return JSON.stringify(auth);
  }

  getJwtToken() {
    return sessionStorage.getItem(this.JWT_TOKEN);
  }

  public getRefreshToken() {
    return sessionStorage.getItem(this.REFRESH_TOKEN);
  }

  private storeTokens(tokens) {
    sessionStorage.setItem(this.JWT_TOKEN, tokens.access_token);
    sessionStorage.setItem(this.REFRESH_TOKEN, tokens.refresh_token);
  }
}